import Vue from 'vue'
import Icon from './Icon/index'
Vue.component('Icon', Icon)